export const impressionStatusColor = {
  NONE: 'none',
  UNDER_VISUAL_THRESHOLD: 'rgba(0, 0, 255, 0.5)',
  OVER_VISUAL_THRESHOLD: 'rgba(255, 0, 0, 0.5)',
  IMPRESSED: 'rgba(0, 255, 0, 0.5)',
}
